import React, { useState, useEffect, useRef } from 'react';
import { Link,} from 'react-router-dom';
import { Link as LinkScroll } from 'react-scroll';
//import { Redirect } from 'react-router-dom';

import uniqid from 'uniqid';

import Swal from 'sweetalert2'

import { getTokenInfo } from '../../../UseToken';
//import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app

//import parse from 'html-react-parser';

import ReactHtmlParser/*, { processNodes, convertNodeToElement, htmlparser2 }*/ from 'react-html-parser';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faClock } from "@fortawesome/free-solid-svg-icons";

import {
	reqGET,
	reqPOST,
	//reqDELETE,
	reqPUT,
	reqFILE,
	//repo_banner_link,
	//content_language,
} from '../../../Utils';
import Hosts from '../../../Hosts';

import Main from '../../Main/Init'

import { language } from './Language';
//import { el } from 'date-fns/locale';
//import { reduce } from 'core-js/core/array';

export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const data_mail = {
		id: '',
		info: {
			companycode: getTokenInfo().companycode,
			type: 'message',
			layout: 'normal',
			from: {
				id: getTokenInfo().id, 
				name: getTokenInfo().name 
			},
			course: {
				id: '',
				name: ''
			},
			to: {
				id: '', 
				name: ''
			},
			date: {
				received: '',
				read: '',
				replied: '',
			},
			tags: [],
			status: 'new'
		},
		content: [{
			subject: '',
			message: '',
			attachment: []
		}]
	}

	//const [dados2, set_dados_2] = useState('');

	const [lang, set_lang] = useState('pt');
	const [uid, ] = useState(uniqid());

	//const [disabled, set_disabled] = useState(false)

	const [isloading, setLoading] = useState(true);

	const [refresh, setRefresh] = useState(0);
	
	//const [isRedirect, setRedirect] = useState(false);

	//const [show_delete_button, set_show_delete_button] = useState(false);

	const [is_edit, set_is_edit] = useState(false)

	//const add_trainers_permission = ('Administrador' === getTokenInfo().profile || 'Gestor de formações' === getTokenInfo().profile || 'Coordenador de formações' === getTokenInfo().profile);

	const [/*editorLoaded*/, setEditorLoaded] = useState(false);

	const [aTypes, ] = useState(['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'])

	const [files_doc, set_files_doc] = useState([]);
	const [files_doc_name, set_files_doc_name] = useState([]);
	const [files_evaluation_name, set_files_evaluation_name] = useState([]);

	const [files_session_doc, set_files_session_doc] = useState([]);
	const [files_session_doc_name, set_files_session_doc_name] = useState([]);
	

    const [modal_entity_id, set_modal_entity_id] = useState('')
    const [modal_entity_to_name, set_modal_entity_to_name] = useState('')
    //const [modal_entity_from_name, set_modal_entity_from_name] = useState('')
    const [modal_subject, set_modal_subject] = useState('')
    const [modal_message, set_modal_message] = useState('')

    //const [modal_course_id, set_modal_course_id] = useState('')
    const [modal_course_name, set_modal_course_name] = useState('')


	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
				//console.log(res.data[0])
			})
			.catch(error => console.log(error))
	}

	const clean_data = async () => {		
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
	}

	useEffect(() => {
		//setEditorLoaded(true);
		clean_data();

		set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				//set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id'])
					.then(() => {
						setLoading(false)
						setEditorLoaded(true);
					})

				return
			}

			// VAI REGISTAR
			if (test === undefined) {
				setLoading(false);
				return
			}
		} catch {
			// VAI REGISTAR

			//setRedirect(false);
			setLoading(false)

			clean_data()
				.then(() => {
					setEditorLoaded(true);
				})	
		
			return
		}

		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}
	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		var today_submit = new Date()

		if (is_edit === true) {
			//alert('Atualizar PUT')

			if(dados.current.info.uniqid !== undefined)
				delete dados.current.info.uniqid;
				
			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {

					dados.current.info.date.modified.push(today_submit)

					files_doc.forEach(async (el_doc) => {
						if (el_doc !== null) {
							el_doc.forEach(async (el_doc_2) => {
								if (el_doc_2 !== null) {

									await uploadFilesDoc(el_doc_2.files, el_doc_2.order, el_doc_2.module, el_doc_2.ev, el_doc_2.type)

								}
							})
						}
					})
					set_files_doc([])
					set_files_doc_name([])
					set_files_evaluation_name([])

					files_session_doc.forEach(async (el_doc) => {
						if (el_doc !== null) {
							el_doc.forEach(async (el_doc_2) => {
								if (el_doc_2 !== null) {

									await uploadSessionFilesDoc(el_doc_2.files, el_doc_2.order, el_doc_2.module, el_doc_2.session, el_doc_2.type)

								}
							})
						}
					})
					set_files_session_doc([])
					set_files_session_doc_name([])

					reqPUT(api_crud_route, dados.current)
						.then(() => { 
							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				}
			})
		} else {
			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					dados.current.info['uniqid'] = uid
					dados.current.info.date.creation = today_submit
					reqPOST(api_crud_route, dados.current)
						.then(() => { 

							reqGET(`${api_crud_base}/formation/course/uniqid/${getTokenInfo().companycode}/${uid}`)
								.then(res => {
									//console.log(res.data)
									dados.current.id = res.data[0].id

									set_is_edit(true)
									//set_show_delete_button(true)
								})
								.catch(() => 404)

							//props.history.push(endpoints.list) 
						})
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})
		}
	}

	/*const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const handle_change_content_nolang = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.content[0][name] = value)
		
		console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		console.log('Dados Current:' + JSON.stringify(dados))
	}*/

	/*const handle_change_info_select = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name]['id'] = value)
		set_dados(dados.current.info[name]['name'] = '')
	}*/

	const onChangeHandlerFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { order, mid, evid, type } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			let ext = v.name.substring(v.name.lastIndexOf(".") + 1);

			if ((aTypes.includes(ext)) && (v.size < 10485760)) {
				storedFiles.push(v);

				if(type === 'doc') {
					let aux2 = files_doc_name
					if(aux2[mid] === undefined) {
						aux2[mid] = []
					}
					aux2[mid].push({ name: v.name, size: v.size })
					set_files_doc_name(aux2)
				}
				else {
					let aux3 = files_evaluation_name
					if(aux3[mid] === undefined)
						aux3[mid] = []
					if(aux3[mid][evid] === undefined)
						aux3[mid][evid] = []
						
					aux3[mid][evid] = { name: v.name, size: v.size }
					set_files_evaluation_name(aux3)
				}

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				console.log(language[lang].upload_file_error + v.name);
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		});

		let files_aux = files_doc
		if(files_aux[mid] === undefined)
			files_aux[mid] = []
		files_aux[mid].push({ files: storedFiles, order: order, module: mid, ev: evid, type: type })
		set_files_doc(files_aux)
	}

	const onChangeHandlerSessionFilesDoc = (e) => {
		const { files, dataset } = e.target;
		const { order, mid, sessionid, type } = dataset

		let storedFiles = [];
		let filesArray = Array.prototype.slice.call(files);

		filesArray.forEach(async (v) => {
			let ext = v.name.substring(v.name.lastIndexOf(".") + 1);

			if ((aTypes.includes(ext)) && (v.size < 10485760)) {
				storedFiles.push(v);

				if(type === 'doc') {
					let aux2 = files_session_doc_name
					if(aux2[sessionid] === undefined) {
						aux2[sessionid] = []
					}
					aux2[sessionid].push({ name: v.name, size: v.size })
					set_files_session_doc_name(aux2)
				}
				else {
					/*let aux3 = files_evaluation_name
					if(aux3[mid] === undefined)
						aux3[mid] = []
					if(aux3[mid][evid] === undefined)
						aux3[mid][evid] = []
						
					aux3[mid][evid] = { name: v.name, size: v.size }
					set_files_evaluation_name(aux3)*/
				}

				set_dados(dados.current,)
				setRefresh(refresh + 1)
			}
			else {
				console.log(language[lang].upload_file_error + v.name);
				Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			}
		});

		let files_aux = files_session_doc
		if(files_aux[sessionid] === undefined)
			files_aux[sessionid] = []
		files_aux[sessionid].push({ files: storedFiles, order: order, module: mid, session: sessionid, type: type })
		set_files_session_doc(files_aux)
	}

	const uploadFilesDoc = (files, order, mid, evid, type) => {
		let aux = []

		files.forEach((element) => {
			//if (element.type === "application/pdf") {
				aux.push(element)

				uploadFile(element, order, mid, evid, type)
					.then(() => {
						//console.log('success')
					})
			//}
			//else {
			//	Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			//}
		})
	}

	const uploadSessionFilesDoc = (files, order, mid, sessionid, type) => {
		let aux = []

		files.forEach((element) => {
			//if (element.type === "application/pdf") {
				aux.push(element)

				uploadSessionFile(element, order, mid, sessionid, type)
					.then(() => {
						//console.log('success')
					})
			//}
			//else {
			//	Swal.fire('Formato do ficheiro incorrecto!', '', 'info')
			//}
		})
	}

	const uploadFile = async (file, order, mid, evid, type) => {

		const formData = new FormData()
		formData.append('files', file)
		formData.append('id', mid)
		formData.append('formation_id', dados.current.id)
		formData.append('file_name', file.name)
		formData.append('type', 'user')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/formation' + dados.current.id + '/module' + mid + '/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				/*let x = {
					id: '',
					info: {
						companycode: getTokenInfo().companycode,
						type: res.data.mimetype,
						link: res.data.path + '/' + res.data.name,
						size: res.data.size,
						date: today_file
					},
					content: {
						name: file.name,
						description: '',
						lang: []
					}
				}*/

				if (type === 'doc') {

					dados.current.content[order]['modules'].forEach((el_m, k_m) => {

						if(parseInt(el_m.id) === parseInt(mid)) {
							dados.current.content[order]['modules'][k_m]['trainees'].forEach(el_t => {
								if(el_t.trainee_id === getTokenInfo().id) {
									if(el_t['files'] === undefined) {
										el_t['files'] = []
									}
				
									el_t['files'].push({
										id: '',
										link: res.data.path + '/' + res.data.name,
										name: file.name,
										description: '',
										date: today_file,
										type: type,
										order: order
									})
								}
							})
						}

					})

				}
				else if(type === 'evaluation') {

					dados.current.content[order]['modules'].forEach((el_m, k_m) => {

						if(parseInt(el_m.id) === parseInt(mid)) {
							dados.current.content[order]['modules'][k_m]['trainees'].forEach(el_t => {
								if(el_t.trainee_id === getTokenInfo().id) {
									if(el_t['evaluation_files'] === undefined) {
										el_t['evaluation_files'] = []
									}
				
									el_t['evaluation_files'][evid] = {
										id: '',
										link: res.data.path + '/' + res.data.name,
										name: file.name,
										description: '',
										date: today_file,
										type: type,
										order: order
									}
								}
							})
						}

					})

				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const uploadSessionFile = async (file, order, mid, sessionid, type) => {

		const formData = new FormData()
		formData.append('files', file)
		formData.append('module_id', mid)
		formData.append('session_id', sessionid)
		formData.append('formation_id', dados.current.id)
		formData.append('user_id', parseInt(getTokenInfo().id))
		formData.append('file_name', file.name)
		formData.append('type', 'user')
		formData.append('companycode', dados.current.info.companycode)
		formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/formation' + dados.current.id + '/module' + mid + '/');

		return await reqFILE(`${api_crud_base}/multimedia/file`, formData)
			.then((res) => {
				var today_file = new Date()

				if (type === 'doc') {

					dados.current.content[order]['modules'].forEach((el_m, k_m) => {

						if(parseInt(el_m.id) === parseInt(mid)) {

							el_m['sessions'].forEach((el_s, el_si) => {
								if(parseInt(el_si) === parseInt(sessionid)) {
									
									el_s['trainees'].forEach(el_t => {
										if(parseInt(el_t.trainee_id) === parseInt(getTokenInfo().id)) {
											if(el_t['files'] === undefined) {
												el_t['files'] = []
											}
						
											el_t['files'].push({
												id: '',
												link: res.data.path + '/' + res.data.name,
												name: file.name,
												description: '',
												date: today_file,
												type: type,
												order: order
											})
										}
									})

								}

							})
						}

					})

					setRefresh(refresh + 1)

				}
				else if(type === 'evaluation') {

					/*dados.current.content[order]['modules'].forEach((el_m, k_m) => {

						if(parseInt(el_m.id) === parseInt(mid)) {
							dados.current.content[order]['modules'][k_m]['trainees'].forEach(el_t => {
								if(el_t.trainee_id === getTokenInfo().id) {
									if(el_t['evaluation_files'] === undefined) {
										el_t['evaluation_files'] = []
									}
				
									el_t['evaluation_files'][evid] = {
										id: '',
										link: res.data.path + '/' + res.data.name,
										name: file.name,
										description: '',
										date: today_file,
										type: type,
										order: order
									}
								}
							})
						}

					})*/

				}

				reqPUT(api_crud_route, dados.current)
					.then(() => {
						//props.history.push(endpoints.list) 
					})
					.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))

				return true

			})
			.catch(erro => console.log('Erro POST File: ' + erro))
	}

	const removeModuleUserTaskFiles = (order, name, link, module_id, index) => {

		//console.log('module_id', module_id)
		//console.log('index do file: ', index)
		dados.current.content[order]['modules'][module_id]['trainees'].forEach((el_t) => {

			if(parseInt(el_t.trainee_id) === parseInt(getTokenInfo().id)) {

				let del_value = el_t['files'].slice(index, index + 1);

				let task_files = el_t['files'].filter(v => v.link !== del_value[0].link);

				set_dados(el_t['files'] = task_files)

				setRefresh(refresh + 1)
				
			}

		})
	}

	const removeSessionUserTaskFiles = (order, name, link, module_id, session, index) => {

		//console.log('module_id', module_id)
		//console.log('index do file: ', index)
		dados.current.content[order]['modules'][module_id]['sessions'][session]['trainees'].forEach((el_t) => {

			if(parseInt(el_t.trainee_id) === parseInt(getTokenInfo().id)) {

				let del_value = el_t['files'].slice(index, index + 1);

				let task_files = el_t['files'].filter(v => v.link !== del_value[0].link);

				set_dados(el_t['files'] = task_files)

				setRefresh(refresh + 1)
				
			}

		})
	}

	const sendMessageModal = (id, name, f_name, m_name) => {
        //console.log(id)

		set_modal_course_name(f_name + ': ' + m_name)

        set_modal_entity_id(id)
        set_modal_entity_to_name(name)

        set_modal_subject('')
        set_modal_message('')

    }

    const handleSendMessage = () => {
        var today = new Date()

        data_mail.info.to.id = modal_entity_id
        data_mail.info.to.name = modal_entity_to_name

        data_mail.info.date.received = today

        data_mail.info.course.name = modal_course_name

        data_mail.content[0].subject = modal_subject
        data_mail.content[0].message = modal_message

        if(modal_subject === '') {
            Swal.fire(language[lang].send_error + ' ' + language[lang].send_error_subject, '', 'info')
            return
        }

        if(modal_message === '') {
            Swal.fire(language[lang].send_error + ' ' + language[lang].send_error_message, '', 'info')
            return
        }

        Swal.fire({
            title: language[lang].send_title,
            text: language[lang].send_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].send_confirm,
            cancelButtonText: language[lang].send_cancel
        })
        .then((result) => {
            if(result.isConfirmed) {
                reqPOST(`${api_crud_base}/app/messages`, data_mail)
                    .then(() => { 
                        Swal.fire(language[lang].send_success, '', 'info')
                        setRefresh(refresh + 1)
                    })
                    .catch(() => Swal.fire(language[lang].send_error, '', 'info'))
            }
        })

        // console.log('Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«Â«')
		// console.log('Dados Current:' + JSON.stringify(dados))
    }

	return isloading ?
		
		<Loader />
		
		:

		<main>
			<form id="form" onSubmit={handleSubmit}>
				<input type="hidden" name="id" value={dados.current.id} />

				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].gest}</h2>
					<span>
						<Link to={{ pathname: endpoints.list }}  >
							{language[lang].content}
						</Link>
						&nbsp;&#47;&nbsp;
						{language[lang].content_gest}
					</span>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row mb-5">

							<div className='col-12 border-bottom'>
								<h3 className="fw-bolder">{language[lang].content}</h3>
							</div>
							<div className='col-12 mt-3'>
								<span className='fw-bold title-red'>{dados.current.content[0].title}</span>
							</div>
							
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].date_begin}&#58;&nbsp;
								</label>
								<span>
									{dados.current.info.date.begin.split('T')[0]}
								</span>
							</div>
							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].financing}&#58;&nbsp;
								</label>
								<span>
									{language[lang][dados.current.content[0].financing]}
								</span>
							</div>

                            {
                                dados.current.content[0].abstract !== '' ?
                                    <div className='col-12 mt-3'>
                                        <label className='fw-bold mb-2'>
                                            {language[lang].objectives}&#58;&nbsp;
                                        </label>
                                        {ReactHtmlParser(dados.current.content[0].abstract)}
                                    </div>
                                : null
                            }

                            {
                                dados.current.content[0].text !== '' ?

                                    <div className='col-12 mt-3'>
                                        <label className='fw-bold mb-2'>
                                            {language[lang].field_description}&#58;&nbsp;
                                        </label>
                                        {ReactHtmlParser(dados.current.content[0].text)}
                                    </div>

                                : null
                            }


                            { 
                                dados.current.info.trainers !== undefined && dados.current.info.trainers.length > 0 ? (
                                    <div className='col-12 mt-3'>
                                        <label className='fw-bold mb-2'>
                                            {language[lang].trainers}&#58;&nbsp;
                                        </label>
                                        <div className="trainers">
                                            {
                                                dados.current.info.trainers.map( ( elem , index ) => {

                                                    let aux_trainer_name = elem.name

                                                    if(index > 0) {
                                                        aux_trainer_name = '; ' + elem.name
                                                    }
                                                    
                                                    if(elem.id === '')
                                                        return ''
                                                    else
                                                        return(
                                                            
                                                            <span  key = { `${index}` }>
                                                                {aux_trainer_name}
                                                            </span>
                                                            
                                                        )
                                                })											
                                            }
                                            
                                        </div>
                                    </div>
                                ) : null 
                            }

							{ 
                               dados.current.content[0].trainees !== undefined && dados.current.content[0].trainees.length > 0 ? (
									
									dados.current.content[0].trainees.map( ( elem , index ) => {

										if(parseInt(elem.trainee_id) === parseInt(getTokenInfo().id)) { 

											if((elem.trainee_final_evaluation !== undefined && elem.trainee_final_evaluation !== '') || (elem.files !== undefined && elem.files.length > 0)) { 

												return (
													<div key = { `${index}` } className='col-12 mt-3'>
														<div className='row'>
															{
																elem.trainee_final_evaluation !== undefined && elem.trainee_final_evaluation !== '' ?
																	<div className='col-12'>
																		<label className='fw-bold'>
																			{language[lang].final_evaluation}&#58;&nbsp;
																		</label>
																		<span>{elem.trainee_final_evaluation}</span>
																	</div>
																: null
															}
															{
																elem.files !== undefined && elem.files.length > 0 ?

																	<div className='col-12 mt-2'>
																		<label className='fw-bold'>
																			{language[lang].certificate}&#58;&nbsp;
																		</label>
																		{
																			elem.files.map((el_f, k_f) => {
																				return (
																						
																					<div key={k_f} className='mt-2'>
																						<a href={el_f.link} alt={el_f.name} target='_blank' rel="noreferrer">
																							<i className="bi bi-bookmark me-2"></i>
																							{el_f.name}
																						</a>
																					</div>
																					
																				)
																			})
																		}

																	</div>
																: null
															}
														</div>

													</div>
												)

											}else return null


										}else return null

									})

								) : null 
							}

							<div className='col-12 mt-3'>
								<label className='fw-bold'>
									{language[lang].modules_evaluation}&#58;&nbsp;
								</label>
								<button
									className="action ms-3"
									type="button" 
									alt={language[lang].modules_evaluation}
									title={language[lang].modules_evaluation}
									data-bs-toggle="modal"
									data-bs-target={"#formationTraineeEvaluationModal"}
									>
										<i className="bi bi-table fs-3"></i>
										<span className="tooltiptext d-none" style={{left: 'unset', right: 10}}>{language[lang].modules_evaluation}</span>
								</button>
								<div className={"modal bg-light fade"} id={"formationTraineeEvaluationModal"} tabIndex="-1" aria-labelledby={"formationTraineeEvaluationModalLabel"} aria-hidden="true" >
									<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
										<div className="modal-content">
											<div className="modal-header">
												<h5 className="modal-title" id={"formationTraineeEvaluationModalLabel"}>
													{dados.current.content[0].title}
												</h5>
												<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
											</div>
											<div className="modal-body">
												<div className="col-12">
													<label className="col-form-label fw-bold">
														{language[lang].module_evaluations}
													</label>
												</div>
												<div className="col-12 mb-4">
													<label className="col-form-label fw-bold d-block">
														{language[lang].attendance_record_label}
													</label>
													<span className='d-flex align-items-center'>
														<i className={"bi bi-clipboard-x fs-3"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>
														&nbsp;
														{language[lang].module_evaluations_soon}
													</span>
												</div>
												<div className="col-12 table-responsive">
													<table className="table table-striped table-hover table-bordered align-middle">
														<thead>
															<tr>
																<th className="fs-6 fw-bold">{language[lang].module}</th>
																<th className="fs-6 fw-bold">{language[lang].module_evaluation}</th>
															</tr>
														</thead>
																		
														<tbody >
															{ 
																dados.current.content[0].modules !== undefined && dados.current.content[0].modules.length > 0 ? (
																	dados.current.content[0].modules.map( ( v , index4 ) => {
																			
																		if(v.id === '')
																			return ''
																		else
																			return(

																				<tr key = {`${index4}`}>
																					<td>
																						<label className="col-form-label">{v.name}</label>
																					</td>
																					{ 
																						v.trainees !== undefined && v.trainees.length > 0 ? (
																							v.trainees.map( ( v2 , index6 ) => {

																								if(parseInt(v2.trainee_id) === parseInt(getTokenInfo().id))
																									return (
																										<td key = {`${index6}`}>
																										
																											{
																												v2.trainee_module_evaluation !== undefined && v2.trainee_module_evaluation !== '' ?
																													v2.trainee_module_evaluation
																												:
																													<i className={"bi bi-clipboard-x fs-4"} alt={language[lang].module_evaluations_soon} title={language[lang].module_evaluations_soon}></i>

																											}

																										</td>

																										
																									)
																								else return null
																							})
																						) : <span className='fw-bold'>{language[lang].trainees_empty}</span>
																					}

																				</tr>

																			)
																	})
																) : <tr>
																		<td>
																			<span className='fw-bold'>{language[lang].modules_empty}</span>
																		</td>
																	</tr>
															}
														</tbody>
													</table>
												</div>
											</div>
											<div className="modal-footer">
												<button type="button" className="btn btn-secondary d-print-none" data-bs-dismiss="modal">{language[lang].close}</button>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="col-12 mt-3">
								<LinkScroll activeClass="active" to="modules" spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary" alt={language[lang].modules} title={language[lang].modules}>
									<img className="assec-mr-15 d-none" alt={language[lang].modules} title={language[lang].modules} src={'./img/plus.svg'} />
									<i className="bi bi-eye text-white me-2"></i>
									{language[lang].modules}
								</LinkScroll>
								<LinkScroll activeClass="active" to="applicants" spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary ms-2 d-none" alt={language[lang].formation_registrations} title={language[lang].formation_registrations}>
									<img className="assec-mr-15 d-none" alt={language[lang].formation_registrations} title={language[lang].formation_registrations} src={'./img/plus.svg'} />
									<i className="bi bi-eye text-white me-2"></i>
									{language[lang].formation_registrations}
								</LinkScroll>
								<LinkScroll activeClass="active" to="trainees" spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary ms-2 d-none" alt={language[lang].trainees} title={language[lang].trainees}>
									<img className="assec-mr-15 d-none" alt={language[lang].trainees} title={language[lang].trainees} src={'./img/plus.svg'} />
									<i className="bi bi-eye text-white me-2"></i>
									{language[lang].trainees}
								</LinkScroll>
							</div>

						</div>

						{
							//formation modules
							is_edit === true && dados.current.content[0].modules.length > 0 ?

								<div className="row mb-3" id="modules">
									<div className='col-12 border-bottom'>
										<h3 className="fw-bolder">{language[lang].modules}</h3>
									</div>
									<div className="col-12 my-3">
										<div className="row">

                                            <div className="accordion border-0 mb-5" id="accordionModule"> 
                                                {
                                                    dados.current.content[0].modules.map((v, k) => {  

														let auxArrayTraineeModule = []
														
														if(v.trainees !== undefined){
															auxArrayTraineeModule = v.trainees.filter(v2 => parseInt(v2.trainee_id) === parseInt(getTokenInfo().id))
                                                        	//console.log('auxArrayTraineeModule', auxArrayTraineeModule)
														}

                                                        return (
                                                            <div key={k}>
                                                                
                                                                <div className="accordion-item mt-3">
                                                                    <div className="accordion-header" id={"heading-" + k}>
                                                                        <button className={"accordion-button" + (k === 0 ? "" : " collapsed") } type="button" data-bs-toggle="collapse" data-bs-target={"#collapse-" + k} aria-expanded="true" aria-controls={"collapse-" + k}>
                                                                            <span>{k + 1} - {v.name}</span>
                                                                        </button>
                                                                    </div>
                                                                
                                                                    <div id={"collapse-" + k} className={"accordion-collapse collapse" + (k === 0 ? " show" : "")} aria-labelledby={"heading-" + k} data-bs-parent="#accordionModule">
                                                                        <div className="accordion-body">

                                                                            <div className='container'>
                                                                                <div className='row'>
                                                                                    <div className='col-12'>
                                                                                        <b>{ReactHtmlParser(v.sessions_number)}&nbsp;{v.sessions_number === '1' ? language[lang].session: language[lang].sessions}&nbsp;&nbsp;&#124;&nbsp;&nbsp;{ReactHtmlParser(v.evaluation)}</b>
                                                                                        <span className="ms-3">
                                                                                            <FontAwesomeIcon className="me-2" icon={faClock} />
                                                                                            {ReactHtmlParser(v.duration)}&nbsp;{language[lang].hours}
                                                                                        </span>
                                                                                    </div>

																					{
																						v.sessions !== undefined && v.sessions.length > 0 ?
																							<div className='col-12 mt-2'>
																								<LinkScroll activeClass="active" to={"module_" + k + "_sessions"} spy={true} smooth={true} offset={-150} duration={500} className="btn btn-secondary" alt={language[lang].sessions_view} title={language[lang].sessions_view}>
																									<i className="bi bi-eye text-white me-2"></i>
																									{language[lang].sessions_view}
																								</LinkScroll>
																							</div>
																						: null
																					}

                                                                                    {
                                                                                        v.description.text !== '' ?
                                                                                            <div className="col-12 mt-3">
                                                                                                {ReactHtmlParser(v.description)}
                                                                                            </div>
                                                                                        : null 
                                                                                    }

                                                                                    {
                                                                                        v.trainer !== undefined && v.trainer.name !== '' ?
                                                                                            <div className='col-12 mt-3'>
                                                                                                <label className='fw-bold mb-2'>
                                                                                                    {language[lang].trainer}&#58;&nbsp;
                                                                                                </label>
                                                                                                {v.trainer.name}
																								<button 
																									type="button"
																									className="btn btn-secondary ms-2"
																									data-bs-toggle="modal" 
																									data-bs-target={"#send_modal"}
																									onClick={() => sendMessageModal(v.trainer.id, v.trainer.name, dados.current.content[0].title, v.name)}
																									alt={language[lang].send_title}
																									title={language[lang].send_title}
																								>
																									{language[lang].send_title}
																									<i className="bi bi-send text-white ms-2"></i>
																								</button>
                                                                                            </div>
                                                                                        : null 
                                                                                    }

																					{
																						auxArrayTraineeModule.length > 0 && auxArrayTraineeModule[0].trainee_module_evaluation !== undefined && auxArrayTraineeModule[0].trainee_module_evaluation !== '' ?

																							<div className='col-12 mt-3'>
                                                                                                <label className='fw-bold mb-2'>
                                                                                                    {language[lang].module_final_evaluation}&#58;&nbsp;
                                                                                                </label>
                                                                                                {auxArrayTraineeModule[0].trainee_module_evaluation}
                                                                                            </div>


																						: null
																					}

                                                                                </div>

                                                                                {
																					//Materiais
                                                                                    v['support_material'] !== undefined && v['support_material'].length > 0 ? (
                                                                                        <div className='row mt-3'>
                                                                                            <div className='col-12 border-bottom'>
                                                                                                <h3 className="fw-bolder">{language[lang].materials}</h3>
                                                                                            </div> 
                                                                                            <div className="col-12 mt-3">
                                                                                                <p className='mb-3'>{language[lang].materials_info}</p>
                                                                                                <label className='fw-bold mb-2'>
                                                                                                    {language[lang].files}&#58;&nbsp;
                                                                                                </label>
                                                                                                {
                                                                                                    v.support_material.map((el_f, k_f) => {
                                                                                                        return (
                                                                                                            <div key={k_f} className='mt-2'>
                                                                                                                <a href={el_f.link} alt="" target='_blank' rel="noreferrer">
																													<i className="bi bi-bookmark me-2"></i>
																													{el_f.name}
																												</a>
                                                                                                            </div>
                                                                                                        )
                                                                                                    })
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    ) : null
                                                                                }

																				{/* Tarefas do módulo */}
                                                                                <div className='row mt-3'>
                                                                                    <div className='col-12 border-bottom'>
                                                                                        <h3 className="fw-bolder">{language[lang].tasks}</h3>
                                                                                    </div> 
                                                                                    <div className="col-12 mt-3">
                                                                                        <p className='mb-3'>{language[lang].tasks_info}</p>
                                                                                        <label className='fw-bold mb-2'>
                                                                                            {language[lang].files}&#58;&nbsp;
                                                                                        </label>
                                                                                    </div>

																					<div className='div-files col-12 mt-3'>
																						<div className="div-form-input col-12 mb-4 custom-file">
																							<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-0"}>{language[lang].doc_choose}</label>
																							<input
																								id={"input-files-0"}
																								type="file"
																								accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
																								data-order={'0'}
																								data-mid={v.id}
																								data-type={'doc'}
																								className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																								onChange={onChangeHandlerFilesDoc}
																								multiple
																							/>
																							<button type="submit" form="form" className="btn btn-sm btn-primary rounded-0 me-2">
																								<span>{language[lang].save}</span>
																							</button>
																						</div>
																					</div>

																					<div className='col-12'>
																						{
																						files_doc_name[v.id] !== undefined ?
																							files_doc_name[v.id].map((el_f, k_f) => {
																								return (
																									<p key={k_f} className='mt-2'>
																										<i className="bi bi-bookmark me-2"></i>
																										{el_f.name}
																									</p>
																								)
																							})
																						:
																							null
																						}

																						{
																						v['trainees'] !== undefined ?
																							v.trainees.map((el_t) => {
																								if(parseInt(el_t.trainee_id) === parseInt(getTokenInfo().id)) {
																									if(el_t['files'] !== undefined) {
																										return ( 
																											el_t.files.map((el_f, k_f) => {
																												return (
																													<div key={k_f} className='d-flex align-items-center mt-2'>
																														<a href={el_f.link} alt={el_f.name} title={el_f.name} target='_blank' rel="noreferrer">
																															<i className="bi bi-bookmark me-2"></i>
																															{el_f.name}
																														</a>
																														<button type="button" onClick={() => removeModuleUserTaskFiles('0', el_f.name, el_f.link, k, k_f)} alt={language[lang].file_remove} title={language[lang].file_remove}>
																															<i className="bi bi-x fs-4 pe-1"></i>
																															<span className='d-none'>{language[lang].file_remove}</span>
																														</button>
																													</div>
																												)
																											})
																										)
																									}
																									else
																										return null
																								}
																								else
																									return null
																							})
																						: null
																						}
																					</div>
                                                                                </div>


																				{
																					//Avaliações do módulo (desactivado)
																					v['evaluations_material'] !== undefined && v['evaluations_material'].length > 0 && 0 ?
																						<div className='row mt-3'>
																							<div className='col-12 border-bottom'>
																								<h3 className="fw-bolder">{language[lang].module_evaluations}</h3>
																							</div> 
																							<div className="col-12 mt-3">
																								<p className='mb-3'>{language[lang].module_evaluations_info}</p>
																								<label className='fw-bold mb-2'>
																									{language[lang].files}&#58;&nbsp;
																								</label>
																							</div>

																							<div className='col-12'>
																								<div className='row'>
																									{
																										v.evaluations_material.map((el_em, k_em) => {
																											if(el_em) {
																												if(el_em !== undefined && el_em !== null) {


																													let auxArrayTraineeEvaluationFiles = []

																													if(auxArrayTraineeModule[0] !== undefined && 0) {
																														auxArrayTraineeEvaluationFiles = auxArrayTraineeModule[0].evaluation_files.filter(v3 => v3.type === el_em.type)
																														//console.log(auxArrayTraineeEvaluationFiles)
																													}
																													
																													return ( 
																														<div key={k_em} className="col-12 col-md-4 mb-5">
																															<h3>{language[lang].module_evaluation + ' ' + (k_em + 1)}</h3>
																															<div className='mt-2'>
																																<a href={el_em.link} alt="" target='_blank' rel="noreferrer">
																																	<i className="bi bi-bookmark me-2"></i>
																																	{el_em.name}
																																</a>
																															</div>

																															{
																																auxArrayTraineeEvaluationFiles.length > 0 && auxArrayTraineeEvaluationFiles[k_em].evaluation !== undefined && auxArrayTraineeEvaluationFiles[k_em].evaluation !== '' ?
																																	
																																	<p className='fw-bold my-2'>{language[lang].module_evaluations_input_attachment_message}</p>
																																:
																																	<div className="div-form-input mt-2 custom-file">
																																		<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-ev-" + k_em}>{language[lang].doc_choose}</label>
																																		<input
																																			id={"input-files-ev-" + k_em}
																																			type="file"
																																			accept=".pdf,.doc,.docx"
																																			data-order={'0'}
																																			data-mid={v.id}
																																			data-evid={k_em}
																																			data-type={'evaluation'}
																																			className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																																			onChange={onChangeHandlerFilesDoc}
																																			multiple
																																		/>
																																		<button type="submit" form="form" className="btn btn-sm btn-primary rounded-0 me-2">
																																			<span>{language[lang].save}</span>
																																		</button>
																																	</div>
																															}

																															{
																																v['trainees'].map((el_t, k_t) => {
																																	if(parseInt(el_t.trainee_id) === parseInt(getTokenInfo().id) && 0) {
																																		if(el_t.evaluation_files[k_em] !== undefined && el_t.evaluation_files[k_em] !== null) {
																																			return (
																																				<div key={k_em} className='mt-2'>
																																					<a href={el_t.evaluation_files[k_em].link} alt="" target='_blank' rel="noreferrer">
																																						<i className="bi bi-bookmark-fill me-2"></i>
																																						{el_t.evaluation_files[k_em].name}
																																					</a>
																																					{
																																						el_t.evaluation_files[k_em].evaluation !== undefined && el_t.evaluation_files[k_em].evaluation !== '' ?
																																							<div className='mt-2'>
																																								<label className='fw-bold mb-2'>
																																									{language[lang].trainer_grade}&#58;&nbsp;
																																								</label>
																																								<span>{el_t.evaluation_files[k_em].evaluation}</span>
																																							</div>
																																						: null
																																					}
																																				</div>
																																				
																																			)
																																		}
																																		else 
																																			return null
																																	}
																																	else 
																																		return null
																																})
																															}
																														</div>
																													)
																												}
																												else
																													return null
																											}
																											else
																												return null
																										})
																									}
																								</div>
																							</div>
																						</div>
																					: null
																				}

																				{/* Sessões */}
																				{
																					v.sessions !== undefined && v.sessions.length > 0 ?
																						<div className='row mt-3' id={"module_" + k + "_sessions"}>
																							<div className='col-12 border-bottom'>
                                                                                                <h3 className="fw-bolder text-capitalize">{language[lang].sessions}</h3>
                                                                                            </div>
																							{
																								v.sessions.map( (v2, index ) => {

																									//console.log(v2)

																									let today_date = new Date().toJSON().split('T')[0]

																									let aux_session_date_expired = false

																									if(v2.data !== undefined && v2.data !== '' && today_date > v2.data){

																										aux_session_date_expired = true
																									}

																									//console.log('Sessão_' + v2.name + ' Data de sessão expirada: ' + aux_session_date_expired)

																									let aux_session_attendance = ''

																									v2.trainees.forEach((v3) => {

																										if(parseInt(v3.trainee_id) === parseInt(getTokenInfo().id)) {

																											if(v3.trainee_session_attendance === true) {

																												aux_session_attendance = true

																											}else {
																												aux_session_attendance = false
																											}

																										}

																									})

																									if(v2.id === '')
																										return ''
																									else
																										return(
																												<div className='col-12 mt-3' key={index}>
																													<div className='session-head d-flex align-items-center mb-3'>
																														<h5 className='mb-0'>
																															{v2.name}
																														</h5>
																														{
																															aux_session_attendance === true ? 
																																<span className="badge bg-success rounded-pill ms-3 py-2">{language[lang].session_completed}</span>
																															:

																															(aux_session_date_expired === false && aux_session_attendance === false && v2.data !== undefined && v2.data !== '') ?
																																<span className="badge bg-warning rounded-pill ms-3 py-2">{language[lang].session_to_start}</span>
																															:
																																<span className="badge bg-danger rounded-pill ms-3 py-2">{language[lang].session_not_completed}</span>
																															
																														}
																														{
																															v2.data !== undefined && v2.data !== '' ?
																																<div className='ms-2'>
																																	<label className='fw-bold'>
																																		{language[lang].date}&#58;&nbsp;
																																	</label>
																																	<span>{v2.data}</span>
																																</div>
																															: null
																														}	
																														<button className="btn btn-link" type="button" data-bs-toggle="collapse" data-bs-target={"#collapseSession_"+index} aria-expanded="false" aria-controls={"collapseSession_"+index}>
																															{language[lang].session_open}
																															<i className="bi bi-plus-circle ms-2"></i>
																														</button>	
																													</div>
																													<div className="collapse" id={"collapseSession_"+index}>
																														<div className='session-info bg-gray-light p-3'>
																															{
																																v2.data !== undefined && v2.data !== '' ?
																																	<div className='mb-2 d-none'>
																																		<label className='fw-bold'>
																																			{language[lang].date}&#58;&nbsp;
																																		</label>
																																		<span>{v2.data}</span>
																																	</div>
																																: null
																															}
																															{
																																((v2.inicio !== undefined && v2.inicio !== '') || (v2.fim !== undefined && v2.fim !== '')) ?
																																	<div className='mb-2'>
																																		{
																																			v2.inicio !== undefined && v2.inicio !== '' ?
																																				<span>
																																					<label className='fw-bold'>
																																						{language[lang].time_start}&#58;&nbsp;
																																					</label>
																																					{v2.inicio}
																																					&nbsp;&nbsp;&#124;&nbsp;&nbsp;
																																				</span>
																																			: null 
																																		}
																																		{
																																			v2.fim !== undefined && v2.fim !== '' ?
																																				<span>
																																					<label className='fw-bold'>
																																						{language[lang].time_end}&#58;&nbsp;
																																					</label>
																																					{v2.fim}
																																				</span>
																																			: null 
																																		}
																																	</div>
																																: null
																															}
																															{
																																v2.description !== undefined && v2.description !== '' ?
																																	<div className='mb-2'>
																																		<label className='fw-bold'>
																																			{language[lang].module_description}&#58;&nbsp;
																																		</label>
																																		{ReactHtmlParser(v2.description)}
																																	</div>
																																: null
																															}
																															{
																																v2.objectives !== undefined && v2.objectives !== '' ?
																																	<div className='mb-2'>
																																		<label className='fw-bold'>
																																			{language[lang].module_objectives}&#58;&nbsp;
																																		</label>
																																		{ReactHtmlParser(v2.objectives)}
																																	</div>
																																: null
																															}
																														</div>
																														{
																															//Materiais de suporte da sessão (pdf's e links)
																															((v2['support_material'] !== undefined && v2['support_material'].length > 0) || (v2['support_material_links'] !== undefined && v2['support_material_links'].length > 0)) ? (
																																<div className='row my-3'>
																																	<div className='col-12 border-bottom'>
																																		<h3 className="fw-bolder">{language[lang].materials}</h3>
																																		<p>{language[lang].materials_session_info}</p>
																																		<p className='mb-3'>{language[lang].materials_session_info_2}</p>
																																	</div> 
																																	{

																																		v2['support_material'] !== undefined && v2['support_material'].length > 0 ? (

																																			('trainee_user' === getTokenInfo().profile && today_date >= v2.data) ? (
																																				<div className='col-12 col-md-6 div-material-files mb-3'>
																																					<div className="col-12 mt-3">
																																						<label className='fw-bold mb-2'>
																																							{language[lang].files}&#58;&nbsp;
																																						</label>
																																						{
																																							v2.support_material.map((el_f, k_f) => {
																																								return (
																																									<div key={k_f} className='mt-2'>
																																										<a href={el_f.link} alt="" target='_blank' rel="noreferrer">
																																											<i className="bi bi-bookmark me-2"></i>
																																											{el_f.name}
																																										</a>
																																									</div>
																																								)
																																							})
																																						}
																																					</div>
																																				</div>
																																			) : null
																																		) : null
																																	}
																																	{

																																		v2['support_material_links'] !== undefined && v2['support_material_links'].length > 0 ? (
																																			('trainee_user' === getTokenInfo().profile && today_date >= v2.data) ? (
																																				<div className='col-12 col-md-6 div-material-links mb-3'>
																																					<div className="col-12 mt-3">
																																						<label className='fw-bold mb-2'>
																																							Links&#58;&nbsp;
																																						</label>
																																						{
																																							v2.support_material_links.map((el_f, k_f) => {
																																								//check if link has http (if not, add it to link)
																																								if(v.link !== undefined && v.link !== '' && v.link.substr(0, 4) !== 'http') {
																																									v.link = 'http://' + v.link;
																																									//console.log(v.link)
																																
																																								}
																																							
																																								if(v.link === '')
																																									return ''
																																								else
																																									return(
																																										<div key = { `${k_f}` } className='mt-2'>
																																											<a href={el_f.link} alt={language[lang].link_open} title={language[lang].link_open} className='text-break' target='_blank' rel="noreferrer">
																																												{el_f.link}
																																											</a>
																																										</div>
																																										
																																									)
																																							})
																																						}
																																					</div>
																																				</div>
																																			) : null
																																		) : null
																																	}
																																</div>
																															) : null
																														}
																														{
																															//Materiais de avaliação da sessão (pdf's e links)
																															((v2['evaluations_material'] !== undefined && v2['evaluations_material'].length > 0) || (v2['evaluations_material_links'] !== undefined && v2['evaluations_material_links'].length > 0)) ? (
																																<div className='row mb-3'>
																																	<div className='col-12 border-bottom'>
																																		<h3 className="fw-bolder">{language[lang].module_evaluations}</h3>
																																		<p>{language[lang].materials_evaluation_session_info}</p>
																																		<p className='mb-3'>{language[lang].materials_session_info_2}</p>
																																	</div> 
																																	{

																																		v2['evaluations_material'] !== undefined && v2['evaluations_material'].length > 0 ? (

																																			('trainee_user' === getTokenInfo().profile && today_date >= v2.data) ? (
																																				<div className='col-12 col-md-6 div-material-files mb-3'>
																																					<div className="col-12 mt-3">
																																						<label className='fw-bold mb-2'>
																																							{language[lang].files}&#58;&nbsp;
																																						</label>
																																						{
																																							v2.evaluations_material.map((el_f, k_f) => {
																																								return (
																																									<div key={k_f} className='mt-2'>
																																										<a href={el_f.link} alt="" target='_blank' rel="noreferrer">
																																											<i className="bi bi-bookmark me-2"></i>
																																											{el_f.name}
																																										</a>
																																									</div>
																																								)
																																							})
																																						}
																																					</div>
																																				</div>
																																			) : null
																																		) : null
																																	}
																																	{

																																		v2['evaluations_material_links'] !== undefined && v2['evaluations_material_links'].length > 0 ? (
																																			('trainee_user' === getTokenInfo().profile && today_date === v2.data) ? (
																																				<div className='col-12 col-md-6 div-material-links mb-3'>
																																					<div className="col-12 mt-3">
																																						<label className='fw-bold mb-2'>
																																							Links&#58;&nbsp;
																																						</label>
																																						{
																																							v2.evaluations_material_links.map((el_f, k_f) => {
																																								//check if link has http (if not, add it to link)
																																								if(v.link !== undefined && v.link !== '' && v.link.substr(0, 4) !== 'http') {
																																									v.link = 'http://' + v.link;
																																									//console.log(v.link)
																																
																																								}
																																							
																																								if(v.link === '')
																																									return ''
																																								else
																																									return(
																																										<div key = { `${k_f}` } className='mt-2'>
																																											<a href={el_f.link} alt={language[lang].link_open} title={language[lang].link_open} className='text-break' target='_blank' rel="noreferrer">
																																												{el_f.link}
																																											</a>
																																										</div>
																																										
																																									)
																																							})
																																						}
																																					</div>
																																				</div>
																																			) : null
																																		) : null
																																	}
																																</div>
																															) : null
																														}

																														{/* Tarefas da sessão */}
																														<div className='row mt-3'>
																															<div className='col-12 border-bottom'>
																																<h3 className="fw-bolder">{language[lang].tasks}</h3>
																															</div> 
																															<div className="col-12 mt-3">
																																<p className='mb-3'>{language[lang].tasks_session_info}</p>
																																<label className='fw-bold mb-2'>
																																	{language[lang].files}&#58;&nbsp;
																																</label>
																															</div>

																															<div className='div-files col-12 mt-3'>
																																<div className="div-form-input col-12 mb-4 custom-file">
																																	<label className="dropzone-select btn btn-sm btn-secondary rounded-0 me-2 dz-clickable" htmlFor={"input-files-session-"+ index}>{language[lang].doc_choose}</label>
																																	<input
																																		id={"input-files-session-"+ index}
																																		type="file"
																																		accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
																																		data-order={'0'}
																																		data-mid={v.id}
																																		data-sessionid={index}
																																		data-type={'doc'}
																																		className="dropzone-select btn btn-sm btn-primary me-2 d-none"
																																		onChange={onChangeHandlerSessionFilesDoc}
																																		multiple
																																	/>
																																	<button type="submit" form="form" className="btn btn-sm btn-primary rounded-0 me-2">
																																		<span>{language[lang].save}</span>
																																	</button>
																																</div>
																															</div>

																															<div className='col-12'>
																																{
																																files_session_doc_name[index] !== undefined ?
																																	files_session_doc_name[index].map((el_f, k_f) => {
																																		return (
																																			<p key={k_f} className='mt-2'>
																																				<i className="bi bi-bookmark me-2"></i>
																																				{el_f.name}
																																			</p>
																																		)
																																	})
																																:
																																	null
																																}

																																{
																																v2['trainees'] !== undefined ?
																																	v2.trainees.map((el_t) => {
																																		if(parseInt(el_t.trainee_id) === parseInt(getTokenInfo().id)) {
																																			if(el_t['files'] !== undefined) {
																																				return ( 
																																					el_t.files.map((el_f, k_f) => {
																																						return (
																																							<div key={k_f} className='d-flex align-items-center mt-2'>
																																								<a href={el_f.link} alt={el_f.name} title={el_f.name} target='_blank' rel="noreferrer">
																																									<i className="bi bi-bookmark me-2"></i>
																																									{el_f.name}
																																								</a>
																																								<button type="button" onClick={() => removeSessionUserTaskFiles('0', el_f.name, el_f.link, k, index, k_f)} alt={language[lang].file_remove} title={language[lang].file_remove}>
																																									<i className="bi bi-x fs-4 pe-1"></i>
																																									<span className='d-none'>{language[lang].file_remove}</span>
																																								</button>
																																							</div>
																																						)
																																					})
																																				)
																																			}
																																			else
																																				return null
																																		}
																																		else
																																			return null
																																	})
																																: null
																																}
																															</div>
																														</div>

																													</div>
																												</div>

																											)
																								})
																							}
																						</div>
																					: null
																				}
                                                                            </div>
                                                                            
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>
                                                        )

                                                    })
                                                }
                                            </div>
										</div>

									</div>
								</div>
							: ''
						}

					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								{
									props.location.state !== undefined && props.location.state.return_button_endpoint === 'list2' ? (
										<li className='nav-item'>
											<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list2 }}  >
												<img alt={language[lang].back} src={'./img/seta_2.svg'} />
												<span>{language[lang].back}</span>
											</Link>

										</li>
									) :
									
										props.location.state !== undefined && props.location.state.go_back_operation === 'main_view' ? (
											<li className="nav-item">
												<Link className="nav-link btn-cancel" to={{ pathname: Main.view.endpoint}}  >
													<img alt={language[lang].back} src={'./img/seta_2.svg'} />
													<span>{language[lang].back}</span>
												</Link>
											</li> 
										) :
											<li className="nav-item">
												<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
													<img alt={language[lang].back} src={'./img/seta_2.svg'} />
													<span>{language[lang].back}</span>
												</Link>
											</li> 
								}
								<li className="nav-item d-none">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</form>

			<div className="modal bg-light fade" tabIndex="-1" id={"send_modal"}>
				<div className="modal-dialog modal-dialog-centered">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">{language[lang].messages_new}</h5>
							<div className="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
								<i className="bi bi-x fs-2"></i>
							</div>
						</div>

						<div className="modal-body">
							<div className="row">
								<div className="col-12">
									<label className="col-form-label fw-bold fs-6 me-2">{language[lang].field_to}: </label>
									{modal_entity_to_name}
								</div>
							</div>

							<div className="row">
								<div className="col-12">
									<label className="col-form-label fw-bold fs-6">{language[lang].field_subject}</label>
									<input type="text" className="form-control mb-3" name="subject" value={modal_subject} placeholder={language[lang].field_subject_placeholder} onChange={(e) => set_modal_subject(e.target.value)}  />
								</div>
							</div>

							<div className="row">
								<div className="col-12">
									<label className="col-form-label fw-bold fs-6">{language[lang].field_message}</label>
									<textarea type="text" className="form-control mb-3" name="subject" value={modal_message} placeholder={language[lang].field_subject_placeholder} onChange={(e) => set_modal_message(e.target.value)}  />
								</div>
							</div>
						</div>

						<div className="modal-footer">
							<button type="button" className="btn btn-light d-none" data-bs-dismiss="modal">{language[lang].close}</button>
							<button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleSendMessage}>{language[lang].send}</button>
						</div>
					</div>
				</div>
			</div> 
		</main>

}
